import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";

const Header = () => {
  return (
    <header className="bg-background border-b border-border sticky top-0 z-50 backdrop-blur-sm bg-background/95 w-full">
      <div className="container mx-auto px-4 py-2 w-full">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center space-x-12">
            <a href="/" className="flex items-center h-14">
              <img 
                src="/lovable-uploads/c7e09fbe-b508-4e9d-b67e-34a41dea1ab9.png" 
                alt="Compare Best Behavioral EMR" 
                className="h-36 w-auto object-contain"
              />
            </a>
            
            <nav className="hidden md:flex items-center space-x-8">
            <a href="/comparisons" className="text-muted-foreground hover:text-foreground transition-colors">
              Comparisons
            </a>
            <DropdownMenu>
              <DropdownMenuTrigger className="text-muted-foreground hover:text-foreground transition-colors flex items-center">
                Resources
                <ChevronDown className="w-4 h-4 ml-1" />
              </DropdownMenuTrigger>
              <DropdownMenuContent align="start" className="w-64">
                <DropdownMenuItem asChild>
                  <a href="/resources/behavioral-health-emr-101" className="w-full">
                    What is EMR Software? (Complete Guide)
                  </a>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <a href="/resources/emr-benefits" className="w-full">
                    7 Key Benefits of EMR Systems
                  </a>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <a href="/resources/how-to-choose-emr" className="w-full">
                    EMR Selection & Buyer's Guide
                  </a>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <a href="/resources/top-emr-solutions" className="w-full">
                    Best EMR Software Comparison
                  </a>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <a href="/resources/emr-implementation" className="w-full">
                    EMR Implementation Best Practices
                  </a>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
            <DropdownMenu>
              <DropdownMenuTrigger className="text-muted-foreground hover:text-foreground transition-colors flex items-center">
                Blog
                <ChevronDown className="w-4 h-4 ml-1" />
              </DropdownMenuTrigger>
              <DropdownMenuContent align="start" className="w-72">
                <DropdownMenuItem asChild>
                  <a href="/blog" className="w-full">All Categories</a>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <a href="/blog/category/how-to-use-features" className="w-full">How to use features in your EMR</a>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <a href="/blog/category/best-emr-at" className="w-full">EMR highlight</a>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <a href="/blog/category/recommended-for-practices" className="w-full">Recommended EMR for specific practices</a>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <a href="/blog/category/why-does-my-emr-have" className="w-full">EMR feature analysis</a>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <a href="/blog/category/navigate-implementation" className="w-full">How to navigate EMR implementation</a>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <a href="/blog/category/billing-and-rcm" className="w-full">Billing & RCM</a>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <a href="/blog/category/integrations-and-interop" className="w-full">Integrations & Interoperability</a>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <a href="/blog/category/security-and-compliance" className="w-full">Security & Compliance</a>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
           </nav>
          </div>
          
          <div className="flex items-center space-x-4">
            <Button variant="outline" size="sm" asChild>
              <a href="/comparisons">Compare EMRs</a>
            </Button>
            <Button size="sm" asChild>
              <a href="/get-recommendation">Get Free Analysis</a>
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;